export const registrationStyle = {
  d_none: {
    display: 'none',
  },
  opacity_0: {
    opacity: 0,
  },
  thumbnail_box: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  thumbnail: {
    position: "relative"
    // maxWidth: "150px",
    // marginRight: "10px",
    // marginBottom: "10px",
  },
  imgPhoto: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    width: "200px",
    height: "200px",
    objectFit: "contain",
    cursor: 'pointer',
  },
  close: {
    position: "absolute",
    top: "-8px",
    right: "-5px",
    fontSize: "20px",
    cursor: "pointer",
  },
  fileUpload: {
    display: "inline-block",
    border: "1px solid #9ca3af",
    borderRadius: "4px",
    padding: "17px 10px",
    cursor: "pointer"
  }
};
